// Eigene Seiten aus dem Seiten-Builder (veröffentlicht) — z. B. für Footer-Links.
import { useEffect, useState } from 'react';
import { cachedGet } from './apiCache';

const API_URL = process.env.REACT_APP_BACKEND_URL;
export const CUSTOM_PAGES_URL = `${API_URL}/api/site-pages/public`;

/** Veröffentlichte eigene Seiten; leer solange geladen wird oder bei Fehler. */
export const useCustomPages = () => {
  const [pages, setPages] = useState([]);
  useEffect(() => {
    let alive = true;
    cachedGet(CUSTOM_PAGES_URL)
      .then((d) => { if (alive) setPages(Array.isArray(d) ? d : []); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return pages;
};
